import styled from 'styled-components';
import { Card } from 'antd';

export const Container = styled.main`
  width: 900px;
  margin: 0 auto;
  height: 100%;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 20px;
  img {
    height: 32px;
    width: 32px;
    margin-right: 10px;
  }
  h1 {
    font-size: 16px;
    color: #333;
    padding-left: 10px;
    margin: 0;
    border-left: 1px solid #e8e8e8;
  }
`;

export const Content = styled.section`
  background: #fff;
  padding: 20px;
  border-radius: 3px;
  min-height: 600px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info {
        margin-left: 12px;
      }
    }
  }
  section.sites {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const SiteCard = styled(Card)`
  width: 280px;
  margin-bottom: 10px;
  flex-shrink: 0;
  flex-grow: 0;
  .detail {
    margin: 0;
    color: #999;
    font-size: 14px;
    &-item {
      display: flex;
    }
  }
`;
